import { Phase, SUBJECT_STATUS_ENUM, SubjectType } from '../Types'
import { format } from 'date-fns'
import { CheckCircleOutlined } from '@ant-design/icons'

/**
 *
 * Written by Stoyan - but moved to this file by dennis.
 * It was part of the old functionanlity for determining a user could be moved forward or backwards in the flow
 *
 * I dont think its needed anymore, but I will leave it here for now.
 *
 * @param sortedPhases
 * @param subjectData
 */
export const getNextPhaseUtil = (sortedPhases, subjectData) => {
  const currentPhaseOrder = subjectData.currentPhase.order

  const nextPhase = sortedPhases
    // Filter the phases to include only those with a different ID and a higher order than the current phase
    .filter((phase) => phase._id !== subjectData.stableId && phase.order > currentPhaseOrder)
    // Reduce to find the phase with the smallest order among the filtered phases
    .reduce((minPhase, phase) => (phase.order < minPhase.order ? phase : minPhase), {
      // minPhase has the first phase from the filtered array
      ...sortedPhases.find((phase) => phase._id !== subjectData.stableId && phase.order > currentPhaseOrder),
    })

  return nextPhase
}

/**
 *
 * Written by Stoyan - but moved to this file by dennis.
 * It was part of the old functionanlity for determining a user could be moved forward or backwards in the flow
 *
 * I dont think its needed anymore, but I will leave it here for now.
 *
 * @param sortedPhases
 * @param subjectData
 */
export const getPreviousPhaseUtil = (sortedPhases, subjectData) => {
  const currentPhaseOrder = subjectData.currentPhase.order

  const previousPhase = sortedPhases
    // Filter the phases to include only those with a different ID and a lower order than the current phase
    .filter((phase) => phase._id !== subjectData.stableId && phase.order < currentPhaseOrder)
    // Reduce to find the phase with the largest order among the filtered phases
    .reduce((maxPhase, phase) => (phase.order > maxPhase.order ? phase : maxPhase), {
      // maxPhase has the first phase from the filtered array
      ...sortedPhases.find((phase) => phase._id !== subjectData.stableId && phase.order < currentPhaseOrder),
    })

  return previousPhase
}

/**
 *
 * Used to determin the current step in the subject journey
 *
 * Originally Written by Stoyan - Dennis moved it here and added types and documentation
 *
 *
 * @param phasesData
 * @param subjectData
 */
export const getCurrentStep = (
  phasesData: Phase[],
  subjectData: SubjectType & { currentPhase: { _id: string } }
): number => {
  const phaseIds = phasesData.map((phase) => phase._id)
  const currentPhaseId = subjectData.currentPhase?._id

  //const onboardingStep = 0
  const completedStep = phaseIds.length + 1 // Last step

  // If the current phase ID matches the onboarding phase ID, return onboardingStep
  /*if (currentPhaseId === onboardingStep) {
    return onboardingStep
  }*/

  // Find the index of the currentPhaseId in the phaseIds array
  const currentStep = phaseIds.indexOf(currentPhaseId) + 1

  if (subjectData.status === SUBJECT_STATUS_ENUM.COMPLETED) {
    return phasesData.length + 1
  }

  // If the current phase ID is not found in phaseIds, use completedStep
  if (currentStep === -1) {
    return completedStep
  }

  // Otherwise, return the currentStep for a regular phase
  return currentStep
}

/**
 *
 * Used to determin the current step in the subject journey
 *
 * Originally Written by Stoyan - Dennis moved it here and added types and documentation
 *
 * @param phasesData
 * @param subjectData
 */

export const buildSteps = (phasesData: Phase[], subjectData: SubjectType) => {
  const setupDate = format(new Date(subjectData.createdAt), 'd MMM yyyy')

  const onboardingStep = { title: 'Initiation', content: setupDate }

  const phasesSteps = phasesData.map((phase, index) => {
    return { title: phase.title }
  })

  const completedStep = {
    title: 'Completed',
    content: '',
    type: SUBJECT_STATUS_ENUM.COMPLETED,
    icon: <CheckCircleOutlined />,
  }

  return [onboardingStep, ...phasesSteps, completedStep]
}

export const getSubjectJourney = (phasesData: Phase[], subjectData: SubjectType) => {
  const currentStep = getCurrentStep(phasesData, subjectData)
  const studySteps = buildSteps(phasesData, subjectData)

  const phaseIds = phasesData.map((phase) => phase._id)
  const currentPhaseId = subjectData.currentPhase._id
  const currentPhaseIndex = phaseIds.indexOf(currentPhaseId)
  const previousPhase = phasesData[currentPhaseIndex - 1] || null
  const nextPhase = phasesData[currentPhaseIndex + 1] || null

  const currentPhase = phasesData[currentPhaseIndex]

  const nextStep = studySteps[currentStep + 1] || null

  /*if (subjectData.status === SUBJECT_STATUS_ENUM.COMPLETED) {
    return { currentStep: studySteps.length - 1, studySteps }
  }*/

  const phaseTitle = currentPhase ? currentPhase.title : 'Unknown title'
  const phaseType = currentPhase ? currentPhase.type : 'Unknown type'

  const isCompleted = subjectData.status === SUBJECT_STATUS_ENUM.COMPLETED

  return {
    currentStep,
    studySteps,
    status: subjectData.status,
    phaseTitle: isCompleted ? 'Completed' : phaseTitle,
    phaseType: isCompleted ? SUBJECT_STATUS_ENUM.COMPLETED : phaseType,
    previousPhase: previousPhase,
    nextPhase: nextPhase,
    nextStep: nextStep,
  }
}
